import React, {Component} from 'react';
import {addScenarioToCart, updateShoppingCart} from '../../actions/closeLoop/addToCartActionCloseLoop'
import { connect } from "react-redux";
import { Alert } from "react-bootstrap";
//import Cart from '../../components/CartComponent'
import {downloadXoscCloseLoop} from '../UserFunctions'
import PropTypes from 'prop-types';
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import DeleteCloseLoopScenarioModal from './DeleteCloseLoopScenarioModal';


class CloseLoopTable extends Component {
    constructor(props){
      super(props)

      this.handleDelete = this.handleDelete.bind(this)
      this.handleDeleteModalClose = this.handleDeleteModalClose.bind(this)
      this.handleUpdate = this.handleUpdate.bind(this)
      this.hanleCheckBox = this.hanleCheckBox.bind(this)
      this.handleAddOperation = this.handleAddOperation.bind(this)
      this.handleDownload = this.handleDownload.bind(this)

      this.state = {
        deletePopUp : undefined,
        deleteSelectedId : undefined,
        downloadError: ""
      }
    }

    handleDownload(e){
        const data = {
          scenario_uuid : e
        }
        const download_url = (window.location.origin).concat('/download_file_close_loop')
        console.log("Downloading....")
        console.log("data : ", data)
        console.log("Url : ", download_url)
        downloadXoscCloseLoop(data, download_url).then(response=>{
            console.log(response)
            if(response){
                if(response.status === 200){
                    let fileName = data['scenario_uuid'].concat('.xosc');
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
                        window.navigator.msSaveOrOpenBlob(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
                            fileName);
                    } else {
                        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download',fileName);
                        document.body.appendChild(link);
                        link.click();
                    }
                }
            }
        }).catch((error) => {
          this.setState(() => {
              return {
                  downloadError: error.response.data.message,
              };
          });
      });


    }
    // class CloseLoopTable extends Component {
    //   constructor(props){
    //     super(props)
  
    //     this.handleDelete = this.handleDelete.bind(this)
    //     this.handleUpdate = this.handleUpdate.bind(this)
    //     this.hanleCheckBox = this.hanleCheckBox.bind(this)
    //     this.handleAddOperation = this.handleAddOperation.bind(this)
    //     this.handleDownload = this.handleDownload.bind(this)
  
    //   }
  
    //   handleDownload(e){
    //       const data = {
    //           scenario_uuid : this.props.data[e.target.id]['Scenario UUID']
    //       }
    //       const download_url = (window.location.origin).concat('/download_file_close_loop')
    //       console.log("Downloading....")
    //       console.log("data : ", data)
    //       console.log("Url : ", download_url)
    //       downloadXoscCloseLoop(data, download_url).then(response=>{
    //           console.log(response)
    //           if(response){
    //               if(response.status === 200){
    //                   let fileName = data['scenario_uuid'].concat('.xosc');
    //                   if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
    //                       window.navigator.msSaveOrOpenBlob(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
    //                           fileName);
    //                   } else {
    //                       const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
    //                       const link = document.createElement('a');
    //                       link.href = url;
    //                       link.setAttribute('download',fileName);
    //                       document.body.appendChild(link);
    //                       link.click();
    //                   }
    //               }
    //           }
    //       })
  
  
    //   }
  

    handleUpdate() {
        console.log("Updated")
    }

    handleDelete(e) {
      console.log("Deleted")
      console.log(" row['Scenario UUID']: ",e)
      this.setState({
        deletePopUp : 1,
        deleteSelectedId : e
      })
      console.log("delete popup:",this.state.deletePopUp)
    }

    handleDeleteModalClose() {
      this.setState({
        deletePopUp : undefined,
        deleteSelectedId : undefined
      })
  }

    hanleCheckBox(event){
      console.log(event.target.id + "is checked")
      console.log(this.props.data[event.target.id].Scenario)
    }

    handleAddOperation(e){
      let buttonValue = e.target.innerHTML
      console.log("Button name : ",buttonValue)
      if (buttonValue === "Add To Group")
      {
      let seq = this.props.count+1
      const obj = {
                  count: this.props.count,
                  items : this.props.data.filter((element) => {
                    return element['Scenario UUID'] === e.target.id
                  }).map((element) => {
                    return {
                              scenario_id : element['Scenario Id'],
                              scenario_uuid : element['Scenario UUID'],
                              sequence : seq,
                          }
                  })
      }
      this.props.dispatch(addScenarioToCart(obj))
    }
    
    else{
      const prev_data = this.props.items
      
      const [removed_Item] = this.props.data.filter((element) => element['Scenario UUID'] === e.target.id)

      const new_data = prev_data.filter((element)=> element.scenario_id != removed_Item['Scenario Id'])


      console.log("new set :", new_data)

      const final_data = new_data.map((data, index)=>{
        if (data.scenario_id < removed_Item['Scenario Id']){
          return {
            scenario_id : data.scenario_id,
            scenario_uuid : data.scenario_uuid,
            sequence : data.sequence,
          }
        }
        if (data.scenario_id > removed_Item['Scenario Id']){
          return {
            scenario_id : data.scenario_id,
            scenario_uuid : data.scenario_uuid,
            sequence : data.sequence-1,
          }
        }
      });

      console.log("This is after deleting :", final_data)

      const obj = {
                  count: this.props.count-1,
                  items : final_data
                }

      this.props.dispatch(updateShoppingCart(obj))

    }


    }

    componentDidMount(){

    }

    render () {
        console.log(this.props)
        const customStyles = {
          rows: {
            style: {
              minHeight: '72px',
            }
          },
          headCells: {
            style: {
              fontWeight: "bold",
              fontSize: "1rem",
              backgroundColor: "white",
              padding: ".75rem",
              verticalAlign: "top",
              borderTop: "1px solid #e9ecef",
              borderBottom: "5px solid #753DFF",
              justifyContent:"center"
            },
          },
          cells: {
            style: {
              backgroundColor: "#C7C9FF",
              fontSize: "0.9rem",
              textAlign: "center",
              verticalAlign: "top",
              borderTop: "5px solid white",
              justifyContent:"center"
            },
          },
        };
  
        
        const baseUrl = "data:image/png;base64,";
          
            const data = this.props.data
            const myIndexedData = data.map((el,index) => ({index, ...el})) 
  
            const columns =
              [{
                name: 'Id',
                selector: 'Scenario Id',
                sortable: true
              },
              {
                name: 'Scenario UUID',
                selector: 'Scenario UUID',
                sortable: true,
                grow: 3,
                cell: row => <div style={{flexWrap: 'wrap'}}>{row['Scenario UUID']}</div>
                
              },
              {
                name: 'Scenario Name',
                selector: 'Scenario Name',
                sortable: true,
                grow: 3,
                cell: row => <div style={{flexWrap: 'wrap'}}>{row['Scenario Name']}</div>
              },
              {
                  name: 'Description',
                  selector:'Description',
                  sortable: false,
                  cell: row => <div style={{alignContent:"center"}}>{row.Description}</div>,
                  grow:3,
               },
              {
                  grow:2,
                  name: 'Image',
                  selector:'Image',
                  sortable: false,
                  cell: (row, index) => <div data-tag="allowRowEvents"><tr className="table-row"><p style={{ textAlign: "center", border: "1px solid black", marginTop : "15px" }}>
                    { row.Image.includes('https://cclp-') ?
                    (<img src={row.Image}
                        id={index}
                        style={{ cursor: 'pointer'}}
                        width="150"
                        height="100">
                    </img>) :
                    (<img src={`${baseUrl}${row.Image.replace(/['"]+/g, '')}`}
                        id={index}
                        style={{ cursor: 'pointer'}}
                        width="150"
                        height="100">
                    </img>)}
                    </p></tr>
                  </div>
              },
              
              {
                grow:4,
                cell: (row, index ) => 
                <div class="form-group">
                   <button type="submit" class="btn" id = {row['Scenario UUID']} style={{backgroundColor:"#4812cc", fontSize:"0.8rem", marginLeft : "20px"}} onClick = {(e) => {this.handleAddOperation(e)}}>
                      {this.props.items.some(obj=>obj.scenario_uuid === row['Scenario UUID'])?"Remove From Group":"Add To Group"}
                   </button>
                 
                 <button
                 className="btn"
                 key={`Delete_${index}`}
                 style={{backgroundColor:"#4812cc", marginLeft : "10px", fontSize:"0.7rem"}}
                 onClick={(e) => {this.handleDelete( row['Scenario UUID'])}}
                 data-toggle="tooltip" data-placement="top" title="Delete"
               >
                 <i className="fas fa-trash"></i>
               </button>

               <button
                 className="btn"
                //  key={`Download_${index}`}
                 style={{backgroundColor:"#4812cc", marginLeft : "10px", fontSize:"0.7rem"}}
                 onClick = {(e) => {this.handleDownload(row['Scenario UUID'])}}
                 data-toggle="tooltip" data-placement="top" title="Download"
               >
                 <i className="fas fa-download"></i>
               </button>
               </div>          
              },
              
          ];

          const tableData = {
              columns,
              data,
            };

        return (
          <div>
            {this.state.downloadError ? (
              <Alert key="danger" variant="danger">
                {this.state.downloadError}
              </Alert>
            ) : undefined }
         <DataTable
          className="dataTables_wrapper"
          columns={columns}
          customStyles={customStyles}
          data={data}
          defaultSortField="Scenario Id"
          defaultSortAsc={true}
          highlightOnHover       
         setFilter
         >
         </DataTable>

          {this.state.deletePopUp != undefined ?
          <DeleteCloseLoopScenarioModal
            deleteSelected={this.state.deletePopUp}
            handleDeleteModalClose={this.handleDeleteModalClose}
            content={this.state.deleteSelectedId}
          /> : undefined }
          </div>
        )
    }
}
CloseLoopTable.propTypes={
data:PropTypes.string,
count:PropTypes.string,
dispatch:PropTypes.string,
items:PropTypes.string,
}
CloseLoopTable.defaultProps= {
data:[],
count:[],
dispatch:[],
items:[],
}
// CloseLoopTable.propTypes={
//   data:PropTypes.string,
//   count:PropTypes.string,
//   dispatch:PropTypes.string,
//   items:PropTypes.string,
//   }
//   CloseLoopTable.defaultProps= {
//   data:[],
//   count:[],
//   dispatch:[],
//   items:[],
//   }
  
const mapStateToProps = (state) => {
    return {
        count : state.close_loop_cart.count,
        items : state.close_loop_cart.items
    }
}
export default connect(mapStateToProps)(CloseLoopTable);
